export const generatedEvidenceGapPriorityLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-evidence-gap-priority-ledger",
  "operatingRule": "Evidence gaps are ranked by explicit planning heuristics so closure work is auditable; rankings are not proof that a gap is resolved.",
  "gapCount": 36,
  "p0GapCount": 3,
  "experimentBacklogCount": 12,
  "categoryCounts": {
    "runtime-sidecar": 3,
    "materials-process": 3,
    "release-readiness": 4,
    "candidate-source-custody": 10,
    "resource-evidence": 5,
    "economics-normalization": 5,
    "scenario-trace-review": 6
  },
  "laneCounts": {
    "P0-critical-path": 3,
    "P1-business-grade": 26,
    "P2-hardening": 7
  },
  "experimentLaneCounts": {
    "runtime-validation": 3,
    "process-physics": 3,
    "release-proof": 1,
    "resource-confidence": 4,
    "economics-sensitivity": 1
  },
  "evidenceHashes": {
    "sourcePromotionLedger": "sha256-bace1b5a9aa61005c905a21ed0714a8068faf28be32f08faa09acdf95f9c3fa4",
    "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
    "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
    "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6"
  },
  "scoringModel": {
    "customerImpact": 0.3,
    "scienceCriticality": 0.28,
    "releaseRisk": 0.24,
    "sourceAvailability": 0.1,
    "executionFriction": -0.08
  },
  "topGaps": [
    {
      "id": "gap-runtime-orekit-propagation-v1",
      "category": "runtime-sidecar",
      "title": "Orekit runtime artifact promotion",
      "priorityScore": 78,
      "priorityLane": "P0-critical-path",
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
    },
    {
      "id": "gap-runtime-gmat-transfer-v1",
      "category": "runtime-sidecar",
      "title": "NASA GMAT runtime artifact promotion",
      "priorityScore": 77,
      "priorityLane": "P0-critical-path",
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
    },
    {
      "id": "gap-runtime-tudat-transfer-v1",
      "category": "runtime-sidecar",
      "title": "Tudat runtime artifact promotion",
      "priorityScore": 77,
      "priorityLane": "P0-critical-path",
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
    },
    {
      "id": "gap-materials-process-oxygen-isru",
      "category": "materials-process",
      "title": "Oxygen Extraction / ISRU process/material proof",
      "priorityScore": 75,
      "priorityLane": "P1-business-grade",
      "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU."
    },
    {
      "id": "gap-readiness-science-math-credibility",
      "category": "release-readiness",
      "title": "Science/math credibility for beta",
      "priorityScore": 75,
      "priorityLane": "P1-business-grade",
      "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated."
    },
    {
      "id": "gap-candidate-source-2026-em",
      "category": "candidate-source-custody",
      "title": "2026 EM candidate source custody intake",
      "priorityScore": 74,
      "priorityLane": "P1-business-grade",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json."
    },
    {
      "id": "gap-candidate-source-2026-jm2",
      "category": "candidate-source-custody",
      "title": "2026 JM2 candidate source custody intake",
      "priorityScore": 74,
      "priorityLane": "P1-business-grade",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json."
    },
    {
      "id": "gap-candidate-source-2026-dn5",
      "category": "candidate-source-custody",
      "title": "2026 DN5 candidate source custody intake",
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json."
    },
    {
      "id": "gap-materials-process-spf-db",
      "category": "materials-process",
      "title": "Superplastic Forming / Diffusion Bonding process/material proof",
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding."
    },
    {
      "id": "gap-materials-process-vacuum-sheet",
      "category": "materials-process",
      "title": "Vacuum Anisotropic Sheet Manufacturing process/material proof",
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing."
    }
  ],
  "experimentBacklog": [
    {
      "id": "experiment-01-gap-runtime-orekit-propagation-v1",
      "linkedGapId": "gap-runtime-orekit-propagation-v1",
      "linkedGapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 78,
      "title": "Test whether resolving Orekit runtime artifact promotion changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Runtime-generated sidecar artifact matching the contract. is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "orekit"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "runtime sidecar artifact and intake report",
        "tool/version/input/output checksum receipt",
        "residual or independent-comparison summary where required",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Raises or lowers mission-design credibility for transfer, event-window, autonomy, or contact assumptions.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "runtime artifact is hand-authored, scaffold-only, or missing tool version evidence",
        "independent comparison is required but residual bounds are absent or failing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "experimentHash": "sha256-2b3b43263ea3d54353e5cce4ed1797cbf0fde1e8899e70559b44131d761f551d"
    },
    {
      "id": "experiment-02-gap-runtime-gmat-transfer-v1",
      "linkedGapId": "gap-runtime-gmat-transfer-v1",
      "linkedGapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 77,
      "title": "Test whether resolving NASA GMAT runtime artifact promotion changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Runtime-generated sidecar artifact matching the contract. is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "gmat"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "runtime sidecar artifact and intake report",
        "tool/version/input/output checksum receipt",
        "residual or independent-comparison summary where required",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Raises or lowers mission-design credibility for transfer, event-window, autonomy, or contact assumptions.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "runtime artifact is hand-authored, scaffold-only, or missing tool version evidence",
        "independent comparison is required but residual bounds are absent or failing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "experimentHash": "sha256-1f2a9b1e8259fc195f0ca63dafe80764be5835aca882c588e05bddecd2415403"
    },
    {
      "id": "experiment-03-gap-runtime-tudat-transfer-v1",
      "linkedGapId": "gap-runtime-tudat-transfer-v1",
      "linkedGapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b",
      "lane": "runtime-validation",
      "priorityLane": "P0-critical-path",
      "priorityScore": 77,
      "title": "Test whether resolving Tudat runtime artifact promotion changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Runtime-generated sidecar artifact matching the contract. is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "sourceIds": [
        "tudat"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "runtime sidecar artifact and intake report",
        "tool/version/input/output checksum receipt",
        "residual or independent-comparison summary where required",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Raises or lowers mission-design credibility for transfer, event-window, autonomy, or contact assumptions.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "runtime artifact is hand-authored, scaffold-only, or missing tool version evidence",
        "independent comparison is required but residual bounds are absent or failing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "experimentHash": "sha256-a0db28faf34bc01b47e6af539f8df61412fca5bc77e5be23fb978c079b24cd8b"
    },
    {
      "id": "experiment-04-gap-materials-process-oxygen-isru",
      "linkedGapId": "gap-materials-process-oxygen-isru",
      "linkedGapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 75,
      "title": "Test whether resolving Oxygen Extraction / ISRU process/material proof changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If feedstock composition with mission/archive citation is attached and passes review, then moon-first, hybrid, orbital-baseline can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "moon-first",
        "hybrid",
        "orbital-baseline"
      ],
      "requiredInputs": [
        "feedstock composition with mission/archive citation",
        "reaction pathway and species mechanism",
        "energy-per-kg oxygen or product output",
        "waste/slag stream and equipment degradation assumption",
        "Cantera chemistry/thermodynamics run",
        "thermal reactor or multiphysics energy-balance run"
      ],
      "sourceIds": [
        "nist-chemistry-webbook",
        "materials-project",
        "cantera",
        "moose-framework",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "material-property or process-runtime evidence packet",
        "thermal/process-fit recalculation receipt",
        "manufacturability confidence update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Clarifies whether this gap is a true ranking driver or only a release/provenance blocker.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "required source, unit, uncertainty, or query metadata is missing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
      "experimentHash": "sha256-8751e645da4147db9d9764a6cde76de9722d7a5c403a587bf97fd94ef7b0f06f"
    },
    {
      "id": "experiment-05-gap-readiness-science-math-credibility",
      "linkedGapId": "gap-readiness-science-math-credibility",
      "linkedGapHash": "sha256-e990668e563242845a8877ab591ddcc69ce7794bafe4542918d6313892927c11",
      "lane": "release-proof",
      "priorityLane": "P1-business-grade",
      "priorityScore": 75,
      "title": "Test whether resolving Science/math credibility for beta changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Keep established formulas covered by unit tests and source-integrity tests. is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "Keep established formulas covered by unit tests and source-integrity tests.",
        "Compare nominal solar irradiance against a cached Horizons Mercury snapshot with explicit tolerance.",
        "Label every planner score as heuristic and prevent heuristic claims from becoming verified physics.",
        "Preserve source query, units, uncertainty, license, and record hash metadata for every promoted model output.",
        "Regenerate deterministic model-artifact bundles before release and block promotion until runtime evidence passes.",
        "Keep seeded uncertainty ranges visible beside deterministic rankings so single-point scenario winners are not overstated."
      ],
      "sourceIds": [],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "release proof receipt",
        "reviewer approval or explicit unresolved blocker",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Clarifies whether this gap is a true ranking driver or only a release/provenance blocker.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "required source, unit, uncertainty, or query metadata is missing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
      "experimentHash": "sha256-9734dd730640f9f7331be94b3fcc73344bd4171a84bc3f75618fe811d479bb3e"
    },
    {
      "id": "experiment-06-gap-candidate-source-2026-em",
      "linkedGapId": "gap-candidate-source-2026-em",
      "linkedGapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 74,
      "title": "Test whether resolving 2026 EM candidate source custody intake changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If SBDB object payload with raw and normalized hashes. is attached and passes review, then asteroid-first, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "candidate-specific taxonomy, spectra, mission, or archive evidence packet",
        "resource claim promotion or explicit no-promotion decision",
        "feedstock confidence and uncertainty update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Determines whether a feedstock candidate can move from geometry-only screening to source-backed resource diligence.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "candidate object identity, orbit solution, or taxonomy/spectra link is ambiguous",
        "resource class is inferred from orbit class without material evidence",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
      "experimentHash": "sha256-972ad36aa06fec061ff2b246e65a74ec9f2c48eb642a309cff0395dd65a049ca"
    },
    {
      "id": "experiment-07-gap-candidate-source-2026-jm2",
      "linkedGapId": "gap-candidate-source-2026-jm2",
      "linkedGapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 74,
      "title": "Test whether resolving 2026 JM2 candidate source custody intake changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If SBDB object payload with raw and normalized hashes. is attached and passes review, then asteroid-first, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "candidate-specific taxonomy, spectra, mission, or archive evidence packet",
        "resource claim promotion or explicit no-promotion decision",
        "feedstock confidence and uncertainty update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Determines whether a feedstock candidate can move from geometry-only screening to source-backed resource diligence.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "candidate object identity, orbit solution, or taxonomy/spectra link is ambiguous",
        "resource class is inferred from orbit class without material evidence",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
      "experimentHash": "sha256-ff9fa981fb2bb895602b6de20346e5fe838fa367a44352b977f25c06020990a6"
    },
    {
      "id": "experiment-08-gap-candidate-source-2026-dn5",
      "linkedGapId": "gap-candidate-source-2026-dn5",
      "linkedGapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving 2026 DN5 candidate source custody intake changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If SBDB object payload with raw and normalized hashes. is attached and passes review, then asteroid-first, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "requiredInputs": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "candidate-specific taxonomy, spectra, mission, or archive evidence packet",
        "resource claim promotion or explicit no-promotion decision",
        "feedstock confidence and uncertainty update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Determines whether a feedstock candidate can move from geometry-only screening to source-backed resource diligence.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "candidate object identity, orbit solution, or taxonomy/spectra link is ambiguous",
        "resource class is inferred from orbit class without material evidence",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
      "experimentHash": "sha256-621f7f959d977f2998b77ff251eea55b0e839c42b3d91f113185ab969381042d"
    },
    {
      "id": "experiment-09-gap-materials-process-spf-db",
      "linkedGapId": "gap-materials-process-spf-db",
      "linkedGapHash": "sha256-ae0748a11a838e23082f8103c11c90d9fe916318d6c4fc39df463393ee9e2e33",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Superplastic Forming / Diffusion Bonding process/material proof changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If alloy and grain-size condition is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "alloy and grain-size condition",
        "forming temperature and strain-rate window",
        "diffusion-bonding pressure/time/temperature window",
        "die/tooling mass and thermal distortion model",
        "thermal cycle energy balance",
        "forming/diffusion-bonding process model"
      ],
      "sourceIds": [
        "nist-codata",
        "nist-chemistry-webbook",
        "materials-project",
        "moose-framework",
        "openfoam"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "material-property or process-runtime evidence packet",
        "thermal/process-fit recalculation receipt",
        "manufacturability confidence update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Clarifies whether this gap is a true ranking driver or only a release/provenance blocker.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "required source, unit, uncertainty, or query metadata is missing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
      "experimentHash": "sha256-5d5ec994e2cf1ef71a7b714db2cca45bea73154371e4a7a12c743d274a53bc77"
    },
    {
      "id": "experiment-10-gap-materials-process-vacuum-sheet",
      "linkedGapId": "gap-materials-process-vacuum-sheet",
      "linkedGapHash": "sha256-8962058e82d93ebe648b6aa41c8720a622df2d1c66100a9837288e03a9aff4e0",
      "lane": "process-physics",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Vacuum Anisotropic Sheet Manufacturing process/material proof changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If candidate alloy or sheet material identifier is attached and passes review, then mercury-orbit, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "mercury-orbit",
        "hybrid"
      ],
      "requiredInputs": [
        "candidate alloy or sheet material identifier",
        "temperature-dependent elastic/plastic property table",
        "vacuum-compatible joining/forming process window",
        "non-destructive evaluation limit and acceptance criterion",
        "MOOSE thermo-mechanical forming residual record",
        "OpenFOAM or equivalent thermal-control case record"
      ],
      "sourceIds": [
        "nist-codata",
        "materials-project",
        "moose-framework",
        "openfoam",
        "pds"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "material-property or process-runtime evidence packet",
        "thermal/process-fit recalculation receipt",
        "manufacturability confidence update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Clarifies whether this gap is a true ranking driver or only a release/provenance blocker.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "required source, unit, uncertainty, or query metadata is missing",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
      "experimentHash": "sha256-51cf969b59ea135750246e39bdd97fd8cd24d18c67c906daa44517646ca56074"
    },
    {
      "id": "experiment-11-gap-resource-taxonomy-spectra-record",
      "linkedGapId": "gap-resource-taxonomy-spectra-record",
      "linkedGapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff",
      "lane": "resource-confidence",
      "priorityLane": "P1-business-grade",
      "priorityScore": 73,
      "title": "Test whether resolving Taxonomy or spectra record changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Resource-class evidence; close approaches cannot imply composition. is attached and passes review, then asteroid-first, hybrid can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "asteroid-first",
        "hybrid"
      ],
      "requiredInputs": [
        "Resource-class evidence; close approaches cannot imply composition."
      ],
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "candidate-specific taxonomy, spectra, mission, or archive evidence packet",
        "resource claim promotion or explicit no-promotion decision",
        "feedstock confidence and uncertainty update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Determines whether a feedstock candidate can move from geometry-only screening to source-backed resource diligence.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "candidate object identity, orbit solution, or taxonomy/spectra link is ambiguous",
        "resource class is inferred from orbit class without material evidence",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
      "experimentHash": "sha256-616e307887247bafb93aa08e62c3253dedd7030096b17c7c599af575b299b07f"
    },
    {
      "id": "experiment-12-gap-economics-launch-list-price-source",
      "linkedGapId": "gap-economics-launch-list-price-source",
      "linkedGapHash": "sha256-9ec3287429344e07a1ef221f40ac591b8ee993eed464f232f27c9cba41776d15",
      "lane": "economics-sensitivity",
      "priorityLane": "P1-business-grade",
      "priorityScore": 71,
      "title": "Test whether resolving Launch list-price source intake changes feasibility ranking confidence",
      "customerQuestion": "What evidence would need to become true for a customer-facing feasibility conclusion or scenario ranking to change?",
      "hypothesis": "If Extract published price table with access timestamp. is attached and passes review, then moon-first, hybrid, orbital-baseline can be rerun with lower uncertainty and clearer blockers.",
      "affectedScenarioIds": [
        "moon-first",
        "hybrid",
        "orbital-baseline"
      ],
      "requiredInputs": [
        "Extract published price table with access timestamp.",
        "Normalize to USD/kg only for the stated payload/orbit class.",
        "Record mission-specific integration, insurance, rideshare constraints, and schedule caveats."
      ],
      "sourceIds": [
        "spacex-rideshare"
      ],
      "acceptanceGates": [
        "Input payloads include source, query, timestamp, units, uncertainty, license/terms note, and hash.",
        "Generated artifact is reproducible from a named command and preserves dependency hashes.",
        "Scenario ranking, uncertainty, and blocker deltas are recorded before and after the experiment.",
        "No verified or commercial claim is promoted unless all linked source, runtime, and review gates pass."
      ],
      "customerDeliverables": [
        "normalized cost or market input record",
        "Monte Carlo or frontier rerun receipt",
        "rank-stability and crossover sensitivity update",
        "reviewed evidence packet with source/runtime hashes",
        "before/after scenario decision delta record",
        "customer-facing blocker and confidence update"
      ],
      "modelRerunPlan": {
        "baselineCommand": "npm run science:report",
        "rerunCommand": "npm run science:report",
        "requiredComparisons": [
          "scenario rank before and after evidence attachment",
          "uncertainty band before and after evidence attachment",
          "blocker count before and after evidence attachment",
          "ledger hash before and after evidence attachment"
        ],
        "decisionDeltaRequired": true
      },
      "decisionImpact": {
        "expectedUse": "Shows whether dated cost or market assumptions move the scenario frontier.",
        "rankingChangeRequired": "Material change means at least one affected scenario changes decision lane, rank position, uncertainty band, or blocker count.",
        "customerDecision": "Use as a paid diligence work order; do not sell as validation until the acceptance gates pass."
      },
      "antiOverclaimChecks": [
        "Do not convert a heuristic score into a verified physics, resource, or economics claim.",
        "Do not remove blockers unless the linked evidence hash and reviewer decision are present.",
        "Do not change customer-facing rankings without a before/after decision-delta artifact.",
        "Do not treat social, forum, or market-interest signals as science or engineering evidence."
      ],
      "stopConditions": [
        "cost, price, capex, opex, or market inputs lack dated source records",
        "rank changes depend on a single unsupported point estimate",
        "source rights, license, or redistribution terms cannot support the intended use",
        "artifact hashes cannot be reproduced from the recorded command and inputs",
        "reviewer approval is missing for any customer-facing promotion"
      ],
      "reproducibility": {
        "planningCommand": "npm run science:report",
        "verificationCommand": "node --test tests/evidence-gap-priority-ledger.test.mjs",
        "expectedOutput": "public/evidence-gap-priority-ledger.json",
        "deterministicBoundary": "This experiment contract plans closure work only. It does not claim the missing source/runtime evidence exists."
      },
      "currentState": "experiment-planned-blocked-until-evidence",
      "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
      "experimentHash": "sha256-9cc9a2319a1e5831df6bac5cb44054e51d74d644d97c6879b13682c92bdeace7"
    }
  ],
  "gaps": [
    {
      "id": "gap-runtime-orekit-propagation-v1",
      "category": "runtime-sidecar",
      "domain": "trajectory-propagation",
      "title": "Orekit runtime artifact promotion",
      "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
      "currentState": "partial-runtime-promotion-contract-gaps",
      "requiredEvidence": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "linkedArtifacts": {
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
        "artifactTemplateHash": "sha256-2e4b5cb2495eb0a40da7b334291976b78e0152823ebfbcc281cd125112704bfc",
        "contractHash": "sha256-f58a64812173f0a91a8d0ac4b3eefed3524179912540073c21537ea9b81f26ff"
      },
      "sourceIds": [
        "orekit"
      ],
      "blockers": [
        "3 sidecar contract(s) still lack promoted runtime artifacts."
      ],
      "scoring": {
        "customerImpact": 92,
        "scienceCriticality": 94,
        "releaseRisk": 96,
        "sourceAvailability": 72,
        "executionFriction": 72
      },
      "priorityScore": 78,
      "priorityLane": "P0-critical-path",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
    },
    {
      "id": "gap-runtime-gmat-transfer-v1",
      "category": "runtime-sidecar",
      "domain": "mission-design-transfer",
      "title": "NASA GMAT runtime artifact promotion",
      "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
      "currentState": "partial-runtime-promotion-contract-gaps",
      "requiredEvidence": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "linkedArtifacts": {
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
        "artifactTemplateHash": "sha256-0bd7273b0c919a05aef324657a34648e241593e92a3686902187a33281e14026",
        "contractHash": "sha256-d0f211a4a572e25c1aa4305535f78823bcbbab1f467a4696563d813e6e202cfd"
      },
      "sourceIds": [
        "gmat"
      ],
      "blockers": [
        "3 sidecar contract(s) still lack promoted runtime artifacts."
      ],
      "scoring": {
        "customerImpact": 92,
        "scienceCriticality": 88,
        "releaseRisk": 96,
        "sourceAvailability": 72,
        "executionFriction": 72
      },
      "priorityScore": 77,
      "priorityLane": "P0-critical-path",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
    },
    {
      "id": "gap-runtime-tudat-transfer-v1",
      "category": "runtime-sidecar",
      "domain": "cross-tool-trajectory-validation",
      "title": "Tudat runtime artifact promotion",
      "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
      "currentState": "partial-runtime-promotion-contract-gaps",
      "requiredEvidence": [
        "Runtime-generated sidecar artifact matching the contract.",
        "Tool/environment version and reproducible command.",
        "Inputs, outputs, and checksum hashes.",
        "Independent comparison with residual bounds.",
        "Reviewed sidecar intake report in evidence/sidecar-intake-reports."
      ],
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "linkedArtifacts": {
        "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
        "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
        "artifactTemplateHash": "sha256-0491e8df008be2668c202dbef8b3bb393ddcb7a3688ea8f0d458e214d25c4995",
        "contractHash": "sha256-ea04034158afb1f40150c168e50717cf068016c88cdd8f0187883058e38bbabb"
      },
      "sourceIds": [
        "tudat"
      ],
      "blockers": [
        "3 sidecar contract(s) still lack promoted runtime artifacts."
      ],
      "scoring": {
        "customerImpact": 92,
        "scienceCriticality": 88,
        "releaseRisk": 96,
        "sourceAvailability": 72,
        "executionFriction": 72
      },
      "priorityScore": 77,
      "priorityLane": "P0-critical-path",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
    },
    {
      "id": "gap-materials-process-oxygen-isru",
      "category": "materials-process",
      "domain": "oxygen-and-basic-feedstock-processing",
      "title": "Oxygen Extraction / ISRU process/material proof",
      "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
      "currentState": "blocked-for-process-physics-proof",
      "requiredEvidence": [
        "feedstock composition with mission/archive citation",
        "reaction pathway and species mechanism",
        "energy-per-kg oxygen or product output",
        "waste/slag stream and equipment degradation assumption",
        "Cantera chemistry/thermodynamics run",
        "thermal reactor or multiphysics energy-balance run",
        "source-backed site feedstock record"
      ],
      "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
      "linkedArtifacts": {
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "evidenceHash": "sha256-e9949f8d6bbce043db6101b136415b59f623e26c4b01d10bf685ba43934313ce",
        "artifactContractId": "artifact-materials-process-v1"
      },
      "sourceIds": [
        "nist-chemistry-webbook",
        "materials-project",
        "cantera",
        "moose-framework",
        "pds"
      ],
      "blockers": [
        "No reviewed material property payload has been promoted for this process.",
        "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
        "No site-specific feedstock or equipment degradation record is attached."
      ],
      "scoring": {
        "customerImpact": 92,
        "scienceCriticality": 88,
        "releaseRisk": 84,
        "sourceAvailability": 76,
        "executionFriction": 62
      },
      "priorityScore": 75,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
    },
    {
      "id": "gap-readiness-science-math-credibility",
      "category": "release-readiness",
      "domain": "Science kernel",
      "title": "Science/math credibility for beta",
      "customerImpact": "Required to raise the beta from testable to release-grade.",
      "currentState": "blocked",
      "requiredEvidence": [
        "Keep established formulas covered by unit tests and source-integrity tests.",
        "Compare nominal solar irradiance against a cached Horizons Mercury snapshot with explicit tolerance.",
        "Label every planner score as heuristic and prevent heuristic claims from becoming verified physics.",
        "Preserve source query, units, uncertainty, license, and record hash metadata for every promoted model output.",
        "Regenerate deterministic model-artifact bundles before release and block promotion until runtime evidence passes.",
        "Keep seeded uncertainty ranges visible beside deterministic rankings so single-point scenario winners are not overstated.",
        "Keep capital, launch-mass, and horizon assumptions visible as planning heuristics until dated cost-source records are attached.",
        "Run live Horizons/SBDB/CAD refresh sampling and preserve generated source-query artifacts before claiming operational ephemerides."
      ],
      "nextAction": "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
      "linkedArtifacts": {
        "readinessCategory": "science-math-credibility"
      },
      "sourceIds": [],
      "blockers": [
        "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
        "Asteroid candidate CAD and SBDB source payloads are captured for the current worklist, but promotion remains blocked until MPC bridging, source-use review, human source-custody approval, and taxonomy/spectra/mission-archive composition evidence replace draft reviewer records."
      ],
      "scoring": {
        "customerImpact": 78,
        "scienceCriticality": 94,
        "releaseRisk": 92,
        "sourceAvailability": 66,
        "executionFriction": 44
      },
      "priorityScore": 75,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-e990668e563242845a8877ab591ddcc69ce7794bafe4542918d6313892927c11"
    },
    {
      "id": "gap-candidate-source-2026-em",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 EM candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-em-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-em-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-5bdb8eb61a495b8a9b53e1cfc73fb5ccdbb5ad0910d3db8a4584ed501c2616f9",
        "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 86,
        "releaseRisk": 84,
        "sourceAvailability": 72,
        "executionFriction": 54
      },
      "priorityScore": 74,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-d96280eb0a5bb0ddddb50e4dc434eb561b643d420cee73d6e82b9dcc28903531"
    },
    {
      "id": "gap-candidate-source-2026-jm2",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 JM2 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jm2-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-b52331ce9a5cd6c17d6aafaa4119aee5533301a87cded5d6a06e684cf07fa134",
        "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 86,
        "releaseRisk": 84,
        "sourceAvailability": 72,
        "executionFriction": 54
      },
      "priorityScore": 74,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-d4d2c6d76b58c5505d26fdb6d6c4ca999f074c6fff41550d0a977c9d4003a23d"
    },
    {
      "id": "gap-candidate-source-2026-dn5",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 DN5 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-dn5-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-620143df6681d87f5385af49ebf5ccc6bd18b20679f3e5e292185d1b5f0327d0",
        "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 86,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-72469172df74568bab75cf56d7fdf37aa178bfdf0ae0ffb65fd6d6b9e1acd433"
    },
    {
      "id": "gap-materials-process-spf-db",
      "category": "materials-process",
      "domain": "aerospace-superplastic-forming-diffusion-bonding",
      "title": "Superplastic Forming / Diffusion Bonding process/material proof",
      "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
      "currentState": "blocked-for-process-physics-proof",
      "requiredEvidence": [
        "alloy and grain-size condition",
        "forming temperature and strain-rate window",
        "diffusion-bonding pressure/time/temperature window",
        "die/tooling mass and thermal distortion model",
        "thermal cycle energy balance",
        "forming/diffusion-bonding process model",
        "tooling mass sensitivity run"
      ],
      "nextAction": "Promote reviewed material records and thermal cycle energy balance for Superplastic Forming / Diffusion Bonding.",
      "linkedArtifacts": {
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "evidenceHash": "sha256-0ada2a49ecad46d6eeab5a8d540299d3dfeec43b6f3b045458b28300396ddb4a",
        "artifactContractId": "artifact-materials-process-v1"
      },
      "sourceIds": [
        "nist-codata",
        "nist-chemistry-webbook",
        "materials-project",
        "moose-framework",
        "openfoam"
      ],
      "blockers": [
        "No reviewed material property payload has been promoted for this process.",
        "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
        "No site-specific feedstock or equipment degradation record is attached."
      ],
      "scoring": {
        "customerImpact": 86,
        "scienceCriticality": 88,
        "releaseRisk": 84,
        "sourceAvailability": 76,
        "executionFriction": 62
      },
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-ae0748a11a838e23082f8103c11c90d9fe916318d6c4fc39df463393ee9e2e33"
    },
    {
      "id": "gap-materials-process-vacuum-sheet",
      "category": "materials-process",
      "domain": "vacuum-structural-manufacturing",
      "title": "Vacuum Anisotropic Sheet Manufacturing process/material proof",
      "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
      "currentState": "blocked-for-process-physics-proof",
      "requiredEvidence": [
        "candidate alloy or sheet material identifier",
        "temperature-dependent elastic/plastic property table",
        "vacuum-compatible joining/forming process window",
        "non-destructive evaluation limit and acceptance criterion",
        "MOOSE thermo-mechanical forming residual record",
        "OpenFOAM or equivalent thermal-control case record",
        "site thermal environment snapshot"
      ],
      "nextAction": "Promote reviewed material records and MOOSE thermo-mechanical forming residual record for Vacuum Anisotropic Sheet Manufacturing.",
      "linkedArtifacts": {
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "evidenceHash": "sha256-a14b6b292954ec489ecd7b2f9a567632c84586662b226b178a572b77121edc2b",
        "artifactContractId": "artifact-materials-process-v1"
      },
      "sourceIds": [
        "nist-codata",
        "materials-project",
        "moose-framework",
        "openfoam",
        "pds"
      ],
      "blockers": [
        "No reviewed material property payload has been promoted for this process.",
        "No process-specific Cantera/MOOSE/OpenFOAM/runtime artifact has been promoted.",
        "No site-specific feedstock or equipment degradation record is attached."
      ],
      "scoring": {
        "customerImpact": 86,
        "scienceCriticality": 88,
        "releaseRisk": 84,
        "sourceAvailability": 76,
        "executionFriction": 70
      },
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-8962058e82d93ebe648b6aa41c8720a622df2d1c66100a9837288e03a9aff4e0"
    },
    {
      "id": "gap-resource-taxonomy-spectra-record",
      "category": "resource-evidence",
      "domain": "small-body-and-resource-evidence",
      "title": "Taxonomy or spectra record",
      "customerImpact": "Required before asteroid/feedstock records can support resource claims.",
      "currentState": "blocked-resource-promotion",
      "requiredEvidence": [
        "Resource-class evidence; close approaches cannot imply composition."
      ],
      "nextAction": "Attach Taxonomy or spectra record records for candidate objects with hashes and source citations.",
      "linkedArtifacts": {
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "blockers": [
        "Asteroid candidates are still blocked from resource promotion."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 94,
        "releaseRisk": 78,
        "sourceAvailability": 72,
        "executionFriction": 68
      },
      "priorityScore": 73,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-9db13bf7dcfd4714e258eaf1832f2100875911d77f71633f871082fd8ae097ff"
    },
    {
      "id": "gap-economics-launch-list-price-source",
      "category": "economics-normalization",
      "domain": "launch-cost",
      "title": "Launch list-price source intake",
      "customerImpact": "Required before price, ROI, demand, or investment claims can be made.",
      "currentState": "blocked-for-commercial-economics",
      "requiredEvidence": [
        "Extract published price table with access timestamp.",
        "Normalize to USD/kg only for the stated payload/orbit class.",
        "Record mission-specific integration, insurance, rideshare constraints, and schedule caveats."
      ],
      "nextAction": "Normalize launch-cost records into model-ready numeric inputs with calibration artifacts.",
      "linkedArtifacts": {
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "evidenceHash": "sha256-dc2d39008cb499d8ecb84fcf7869779f2a12785e52c821d9af3ffc96d5713668"
      },
      "sourceIds": [
        "spacex-rideshare"
      ],
      "blockers": [
        "Source data is not normalized into model-ready numeric inputs.",
        "No calibrated capex/opex/market model artifact is attached.",
        "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
      ],
      "scoring": {
        "customerImpact": 96,
        "scienceCriticality": 64,
        "releaseRisk": 88,
        "sourceAvailability": 78,
        "executionFriction": 56
      },
      "priorityScore": 71,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-9ec3287429344e07a1ef221f40ac591b8ee993eed464f232f27c9cba41776d15"
    },
    {
      "id": "gap-economics-capex-estimating-method",
      "category": "economics-normalization",
      "domain": "capex",
      "title": "Capex estimating method",
      "customerImpact": "Required before price, ROI, demand, or investment claims can be made.",
      "currentState": "blocked-for-commercial-economics",
      "requiredEvidence": [
        "Select estimating class and analogy/parametric method.",
        "Attach normalization year and inflation/escalation rule.",
        "Tie maturity, schedule, and risk reserves to scenario-specific work breakdown structure."
      ],
      "nextAction": "Normalize capex records into model-ready numeric inputs with calibration artifacts.",
      "linkedArtifacts": {
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "evidenceHash": "sha256-201b078539f5927b396f839f3cd93f36e23e12487af804803f06a2a7204d0bdc"
      },
      "sourceIds": [
        "nasa-cost-estimating-handbook",
        "nasa-se-handbook"
      ],
      "blockers": [
        "Source data is not normalized into model-ready numeric inputs.",
        "No calibrated capex/opex/market model artifact is attached.",
        "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 64,
        "releaseRisk": 88,
        "sourceAvailability": 78,
        "executionFriction": 56
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-7413a56a815cc9cf360707209e566a759709a1676cf0d0aa9ddd8b7fda68a4df"
    },
    {
      "id": "gap-economics-lunar-delivery-contract-envelope",
      "category": "economics-normalization",
      "domain": "lunar-delivery-cost",
      "title": "Commercial lunar delivery contract envelope",
      "customerImpact": "Required before price, ROI, demand, or investment claims can be made.",
      "currentState": "blocked-for-commercial-economics",
      "requiredEvidence": [
        "Resolve task-order awards and modifications from NASA/USAspending.",
        "Separate payload integration, launch, landing, mission operations, and provider-specific scope.",
        "Avoid applying the total CLPS envelope as a per-mission cost."
      ],
      "nextAction": "Normalize lunar-delivery-cost records into model-ready numeric inputs with calibration artifacts.",
      "linkedArtifacts": {
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "evidenceHash": "sha256-cd8dcde2d818fc3b2eed2614a7e0c7d54dd222d3073ac13a9074d394a7473dd7"
      },
      "sourceIds": [
        "nasa-clps",
        "usaspending"
      ],
      "blockers": [
        "Source data is not normalized into model-ready numeric inputs.",
        "No calibrated capex/opex/market model artifact is attached.",
        "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 64,
        "releaseRisk": 88,
        "sourceAvailability": 78,
        "executionFriction": 56
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-02efe5d526fdd188a9e61dfc53ed80418e96900ada3a1317e46a523ca527ed40"
    },
    {
      "id": "gap-economics-market-and-company-financial-context",
      "category": "economics-normalization",
      "domain": "market",
      "title": "Market and company financial context",
      "customerImpact": "Required before price, ROI, demand, or investment claims can be made.",
      "currentState": "blocked-for-commercial-economics",
      "requiredEvidence": [
        "Attach company filings and award records by CIK, accession, award id, and date.",
        "Separate revenue, backlog, capex, R&D, and risk-factor text.",
        "Do not infer demand from social or forum signals without primary-source bridge."
      ],
      "nextAction": "Normalize market records into model-ready numeric inputs with calibration artifacts.",
      "linkedArtifacts": {
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "evidenceHash": "sha256-228cb6a20a2fca0ac790d144a2ca2706132057aa5ffdba4d96a88c16176898af"
      },
      "sourceIds": [
        "sec-edgar",
        "usaspending"
      ],
      "blockers": [
        "Source data is not normalized into model-ready numeric inputs.",
        "No calibrated capex/opex/market model artifact is attached.",
        "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 64,
        "releaseRisk": 88,
        "sourceAvailability": 78,
        "executionFriction": 56
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-1479e55b6a27db3bc42d561c2fa8c2364d890ad3b1d1418e114b63e9a760c076"
    },
    {
      "id": "gap-economics-opex-and-operations-reserve-method",
      "category": "economics-normalization",
      "domain": "opex",
      "title": "Opex and operations reserve method",
      "customerImpact": "Required before price, ROI, demand, or investment claims can be made.",
      "currentState": "blocked-for-commercial-economics",
      "requiredEvidence": [
        "Define operations concept and communication architecture.",
        "Separate ground operations, autonomy software, maintenance, spares, and review cadence.",
        "Calibrate reserves against comparable mission/program records where legally available."
      ],
      "nextAction": "Normalize opex records into model-ready numeric inputs with calibration artifacts.",
      "linkedArtifacts": {
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "evidenceHash": "sha256-1717c7cfc8352054c975089aba9237837c363a0ca69235f9e640c6644e583acc"
      },
      "sourceIds": [
        "nasa-cost-estimating-handbook",
        "nasa-dtn",
        "ccsds"
      ],
      "blockers": [
        "Source data is not normalized into model-ready numeric inputs.",
        "No calibrated capex/opex/market model artifact is attached.",
        "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
      ],
      "scoring": {
        "customerImpact": 88,
        "scienceCriticality": 64,
        "releaseRisk": 88,
        "sourceAvailability": 78,
        "executionFriction": 56
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-b9d83f5c025d242ec5eb0a16cce32fb6de52ff47baf8e6770663fa64dabfbe04"
    },
    {
      "id": "gap-resource-cad-close-approach-record",
      "category": "resource-evidence",
      "domain": "small-body-and-resource-evidence",
      "title": "CAD close-approach record",
      "customerImpact": "Required before asteroid/feedstock records can support resource claims.",
      "currentState": "blocked-resource-promotion",
      "requiredEvidence": [
        "Close approach cadence, nominal distance, relative velocity, and date range."
      ],
      "nextAction": "Attach CAD close-approach record records for candidate objects with hashes and source citations.",
      "linkedArtifacts": {
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      "sourceIds": [
        "cad-api"
      ],
      "blockers": [
        "Asteroid candidates are still blocked from resource promotion."
      ],
      "scoring": {
        "customerImpact": 82,
        "scienceCriticality": 82,
        "releaseRisk": 78,
        "sourceAvailability": 72,
        "executionFriction": 52
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-8fc55bc0f1f95de19673711ea406c890ceec3b66c4defee971ec3228592c2c74"
    },
    {
      "id": "gap-resource-mission-or-archive-product",
      "category": "resource-evidence",
      "domain": "small-body-and-resource-evidence",
      "title": "Mission/archive product",
      "customerImpact": "Required before asteroid/feedstock records can support resource claims.",
      "currentState": "blocked-resource-promotion",
      "requiredEvidence": [
        "Independent mission data or archive product where material claims depend on composition."
      ],
      "nextAction": "Attach Mission/archive product records for candidate objects with hashes and source citations.",
      "linkedArtifacts": {
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      "sourceIds": [
        "pds",
        "esa-psa",
        "jaxa-darts"
      ],
      "blockers": [
        "Asteroid candidates are still blocked from resource promotion."
      ],
      "scoring": {
        "customerImpact": 82,
        "scienceCriticality": 82,
        "releaseRisk": 78,
        "sourceAvailability": 72,
        "executionFriction": 52
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-8c7f9a7e86309ac82dcb0320ab62b11555bc49b14ab3f3fefa9b10e000261036"
    },
    {
      "id": "gap-resource-mpc-observation-bridge",
      "category": "resource-evidence",
      "domain": "small-body-and-resource-evidence",
      "title": "MPC observation bridge",
      "customerImpact": "Required before asteroid/feedstock records can support resource claims.",
      "currentState": "blocked-resource-promotion",
      "requiredEvidence": [
        "Observation context that explains orbit confidence and designation lineage."
      ],
      "nextAction": "Attach MPC observation bridge records for candidate objects with hashes and source citations.",
      "linkedArtifacts": {
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      "sourceIds": [
        "mpc"
      ],
      "blockers": [
        "Asteroid candidates are still blocked from resource promotion."
      ],
      "scoring": {
        "customerImpact": 82,
        "scienceCriticality": 82,
        "releaseRisk": 78,
        "sourceAvailability": 72,
        "executionFriction": 52
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-1f578fbb47b5ebc0f44778b06ed6b6c850ea36eec18607c6077aedc809b65309"
    },
    {
      "id": "gap-resource-sbdb-orbit-record",
      "category": "resource-evidence",
      "domain": "small-body-and-resource-evidence",
      "title": "SBDB orbit and physical-property record",
      "customerImpact": "Required before asteroid/feedstock records can support resource claims.",
      "currentState": "blocked-resource-promotion",
      "requiredEvidence": [
        "Orbit solution, condition code, absolute magnitude, diameter fields, and physical property provenance."
      ],
      "nextAction": "Attach SBDB orbit and physical-property record records for candidate objects with hashes and source citations.",
      "linkedArtifacts": {
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22"
      },
      "sourceIds": [
        "sbdb-api"
      ],
      "blockers": [
        "Asteroid candidates are still blocked from resource promotion."
      ],
      "scoring": {
        "customerImpact": 82,
        "scienceCriticality": 82,
        "releaseRisk": 78,
        "sourceAvailability": 72,
        "executionFriction": 52
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-cf5576baa620019c4c2d21bb4bcc8b4de7cecb89d16b7fb723565209fa14f084"
    },
    {
      "id": "gap-trace-hybrid",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Hybrid Moon -> Asteroid -> Mercury trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims."
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-d733f88bb38e404138d4ac8f6cca29c216f96ef4cfab8d1feb018406ef47b92d",
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "scoring": {
        "customerImpact": 86,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-9b2025b5a713e047c204f589e827d16999d379dfd70d83f2afe5ce703be751cd"
    },
    {
      "id": "gap-trace-moon-first",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Moon-first Bootstrap trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge."
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-4c9d51ef9294289600bc39fd2b99a03df6edf38557eb137e1a48a9bf1b0d3110",
        "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound."
      ],
      "scoring": {
        "customerImpact": 86,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 69,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-a07797a7875d70590b15bfb0660c0d5391f295e6949d908cda489948b8388ce6"
    },
    {
      "id": "gap-candidate-source-2026-et3",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 ET3 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-et3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-et3-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-5307e6095ba506ff9e307252b1b93187560a31d7d43a125df1226e73c39a22d7",
        "payloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-74f4bc84e7ea823c265ec80211167548ff6ed72bc97064d79d0d439737dba7f9"
    },
    {
      "id": "gap-candidate-source-2026-fs5",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 FS5 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-fs5-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-09109b23d6398297094ed3d3b256f48c4a47f25c782a345c919d9de7ab6154c9",
        "payloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-827bd3aee44db5fc618a31ce27ffe6ecd3fb358744fb0d70a7048d965fc0bc7c"
    },
    {
      "id": "gap-candidate-source-2026-hz4",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 HZ4 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-hz4-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-ca56492f342a3ffd2c86d75c51ea4e032263dc65138f58c461ebb42a700b4b92",
        "payloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-9d9dd560b7581f37ddf737dc9e7ac461bffbd398fe1b11473fe309590b73d227"
    },
    {
      "id": "gap-candidate-source-2026-jn4",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 JN4 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jn4-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-db8b7e318dfb4712806ffcd94b5e853eb00e04027da223999f907e3dfd42a8b4",
        "payloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-dc8d4a2f5c93e9e5ef37344887b384fddeaa72bf40230d4ad4fd43476a5899c8"
    },
    {
      "id": "gap-candidate-source-2026-jv3",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 JV3 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-jv3-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-ae4f5464fe7a729075d1796422f376bef5116a139fa7afe89e1f39f2d18c489f",
        "payloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-f8c55ed733b65b3672fb79d86c0847d1ccf231bd775aece43f126a3f48945771"
    },
    {
      "id": "gap-candidate-source-2026-ku1",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 KU1 candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-ku1-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-9f67dd23c5090587d15155d69e13638d980daaa9b46e66af99b0a82c007689d3",
        "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-b38dd56c77c9f8a9c1c8b893a203ffd3193592a54c6590781414b56ccb73cf99"
    },
    {
      "id": "gap-candidate-source-2026-lx",
      "category": "candidate-source-custody",
      "domain": "small-body-and-resource-evidence",
      "title": "2026 LX candidate source custody intake",
      "customerImpact": "Required before asteroid/feedstock screens can move from geometry-only candidates to reviewed object-specific diligence records.",
      "currentState": "blocked-no-candidate-source-custody",
      "requiredEvidence": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "nextAction": "Create and review evidence/source-candidate-payloads/2026-lx-source-intake-payload.json, then validate it into evidence/source-candidate-reports/2026-lx-source-intake-report.json.",
      "linkedArtifacts": {
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "workOrderHash": "sha256-8c14435b45122ce12954b3cdff703649a3c597e4399f447c3d66d06c0615617e",
        "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json"
      },
      "sourceIds": [
        "sbdb-api",
        "cad-api",
        "mpc",
        "pds"
      ],
      "blockers": [
        "No candidate-specific reviewed source custody intake has passed.",
        "Candidate source custody can promote only after reviewed candidate-specific intake passes.",
        "Resource and customer-use promotion still require taxonomy, spectra, mission/archive evidence, and source-use clearance."
      ],
      "scoring": {
        "customerImpact": 80,
        "scienceCriticality": 78,
        "releaseRisk": 84,
        "sourceAvailability": 62,
        "executionFriction": 54
      },
      "priorityScore": 68,
      "priorityLane": "P1-business-grade",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-00800b5fd8d8d2357ce6bb2e7406e8443edea5941cf0925c7fc8e3044c27aa74"
    },
    {
      "id": "gap-readiness-ui-review-readiness",
      "category": "release-readiness",
      "domain": "Product design",
      "title": "UI review readiness",
      "customerImpact": "Required to raise the beta from testable to release-grade.",
      "currentState": "blocked",
      "requiredEvidence": [
        "Finish propagating the code-native SVG logo/wordmark into export payloads and final review artifacts.",
        "Rebuild Command Overview, Scenario Compare, Solar Clock, Body Ledger, Process Lab, and Claims Register from the mockups.",
        "Run a mismatch ledger against the accepted mockups before approval."
      ],
      "nextAction": "The product shell and six primary pages have been rebuilt closer to the accepted mockup direction, but side-by-side screenshot fidelity still needs final page-by-page approval.",
      "linkedArtifacts": {
        "readinessCategory": "ui-review-readiness"
      },
      "sourceIds": [],
      "blockers": [
        "The product shell and six primary pages have been rebuilt closer to the accepted mockup direction, but side-by-side screenshot fidelity still needs final page-by-page approval.",
        "Mobile no-overflow rendering and collapsible navigation are covered, but final typography/spacing approval against the reference set is still pending."
      ],
      "scoring": {
        "customerImpact": 86,
        "scienceCriticality": 58,
        "releaseRisk": 92,
        "sourceAvailability": 66,
        "executionFriction": 52
      },
      "priorityScore": 67,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-45d040aa8b87d03346a7b78747c1b5aebaf6f2e0f0817ffab44ecbaa2f82b274"
    },
    {
      "id": "gap-readiness-deployment-readiness",
      "category": "release-readiness",
      "domain": "Release engineering",
      "title": "Deployment readiness",
      "customerImpact": "Required to raise the beta from testable to release-grade.",
      "currentState": "blocked",
      "requiredEvidence": [
        "Keep `npm run verify` green and deploy the Vite `dist` artifact only after visual approval.",
        "Use `npm run deploy:pages` for repeatable Pages deployment.",
        "Run CI/CD deployment from a named release branch or protected main baseline.",
        "Verify Cloudflare Access with an owner browser session and record the approval evidence."
      ],
      "nextAction": "Cloudflare Pages and the custom hostname are live from a git baseline, and a CI/CD workflow is committed, but the repo still needs a remote/secrets-backed run before it counts as reproducible promotion.",
      "linkedArtifacts": {
        "readinessCategory": "deployment-readiness"
      },
      "sourceIds": [],
      "blockers": [
        "Cloudflare Pages and the custom hostname are live from a git baseline, and a CI/CD workflow is committed, but the repo still needs a remote/secrets-backed run before it counts as reproducible promotion.",
        "Cloudflare Access anonymous challenge and monitor service-token verification pass; owner browser review remains a human approval step."
      ],
      "scoring": {
        "customerImpact": 78,
        "scienceCriticality": 58,
        "releaseRisk": 92,
        "sourceAvailability": 66,
        "executionFriction": 44
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-125cfb5bd18503852c51b05cb7ea0ad4bab35f2b4f8681c273bcb0dabb6d95c4"
    },
    {
      "id": "gap-readiness-public-gated-live",
      "category": "release-readiness",
      "domain": "Cloudflare/DNS",
      "title": "Public/gated website live status",
      "customerImpact": "Required to raise the beta from testable to release-grade.",
      "currentState": "blocked",
      "requiredEvidence": [
        "Record owner/reviewer browser approval after Cloudflare Access login.",
        "Verify alert and recovery delivery once a real webhook or email relay is attached."
      ],
      "nextAction": "The custom hostname is protected by Cloudflare Access; anonymous requests receive an Access challenge and the monitor service token reaches the app.",
      "linkedArtifacts": {
        "readinessCategory": "public-gated-live"
      },
      "sourceIds": [],
      "blockers": [
        "The custom hostname is protected by Cloudflare Access; anonymous requests receive an Access challenge and the monitor service token reaches the app.",
        "A Worker Cron monitor and KV state store are live and healthy, but alert webhook/recovery proof still requires a real webhook or email relay."
      ],
      "scoring": {
        "customerImpact": 78,
        "scienceCriticality": 58,
        "releaseRisk": 92,
        "sourceAvailability": 66,
        "executionFriction": 44
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-7cbc5b5e9c4fa94fdb8e96152bf554bd01f076170c01db6ce814832a6915eda0"
    },
    {
      "id": "gap-trace-asteroid-first",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Asteroid Feedstock-first trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof"
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-d619bbef18fc804057f0cf68a6279068db56356135bf425e70958c3f1b2b904b",
        "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for asteroid-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "scoring": {
        "customerImpact": 72,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-1507bb3a073d36e0376fcdee4f57ae7676eff4e7ece630c25f0ec35df9c8e31e"
    },
    {
      "id": "gap-trace-mars-first",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Mars-first Conventional Expansion trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge."
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-fd5108fc370a65f836309389af914613680a45a2f8d2cd12b9f04f65a9a39068",
        "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "scoring": {
        "customerImpact": 72,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-a001e470feaccc1ac563477c2a78c86baa6c578879e643c6f63c914083e159a0"
    },
    {
      "id": "gap-trace-mercury-orbit",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Mercury Orbit-first trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims."
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-347c3c0291493190d1eaba179b7e37c09366c6c992e8e7a322640eee5bd05757",
        "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mercury-orbit: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "scoring": {
        "customerImpact": 72,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-a5fa55a583c4dbdad7357b606c59584859528aed662014720d5d7ff86c552ab9"
    },
    {
      "id": "gap-trace-mercury-polar",
      "category": "scenario-trace-review",
      "domain": "scenario-diligence",
      "title": "Mercury Polar Surface-first trace blockers",
      "customerImpact": "Keeps scenario-facing diligence honest until upstream evidence clears.",
      "currentState": "blocked-for-commercial-proof",
      "requiredEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims."
      ],
      "nextAction": "Resolve linked source, runtime, economics, and resource blockers before promoting this scenario.",
      "linkedArtifacts": {
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "traceHash": "sha256-5ab13dfa8e8a9fd561a2ee8af012a052ebd58a668b19dda311f91f6532036ecf",
        "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934"
      },
      "sourceIds": [
        "horizons-api",
        "nasa-dtn",
        "nasa-mercury",
        "pds",
        "spice-gf"
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Asteroid/resource candidates are not promoted for resource claims.",
        "Claim claim-helium3: blocked-for-commercial-proof",
        "Claim claim-mercury-core: blocked-for-commercial-proof",
        "Claim claim-spf-separation: blocked-for-commercial-proof",
        "Economics evidence is not promoted for commercial pricing, ROI, or investment claims.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "tudat-transfer-v1 runtime evidence missing for mercury-polar: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "scoring": {
        "customerImpact": 72,
        "scienceCriticality": 76,
        "releaseRisk": 78,
        "sourceAvailability": 70,
        "executionFriction": 48
      },
      "priorityScore": 65,
      "priorityLane": "P2-hardening",
      "claimBoundary": "This is a closure-priority heuristic. It is not evidence, validation, or proof that the gap is resolved.",
      "gapHash": "sha256-99163eaa428fa45c275a16aa56da8c959ddcde28d52917805ba9a1155aaa8262"
    }
  ],
  "ledgerHash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7"
}
;
